import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=6535561e&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=6535561e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535561e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6535561e')) {
      api.createRecord('6535561e', component.options)
    } else {
      api.reload('6535561e', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=6535561e&scoped=true&", function () {
      api.rerender('6535561e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vendor/vue-medialibrary/src/components/svgs/Error.vue"
export default component.exports